import { ActionContext } from 'vuex';
import { AppState } from './types';

export default {};
